export function processComments(rawComments) {
  // 1. If it's already an array, return it safely
  if (Array.isArray(rawComments)) {
    return rawComments;
  }

  // 2. If it's null, undefined, or empty, return empty array
  if (!rawComments) {
    return [];
  }

  // 3. If it's a string, let's process it
  if (typeof rawComments === 'string') {
    const trimmed = rawComments.trim();

    // A. First, try standard JSON parse (Handles valid JSON like ["A", "B"])
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      // If JSON fails, continue to manual parsing
    }

    // B. Manual Parse: Handle brackets with single quotes "['A', 'B']" or no quotes "[A, B]"
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      // Remove first and last character (the brackets)
      const content = trimmed.slice(1, -1);
      
      // If empty brackets "[]", return empty array
      if (!content.trim()) return [];

      // Split by comma and clean up each item
      return content.split(',').map(item => {
        let cleanItem = item.trim();
        // Remove surrounding quotes if they exist (both ' and ")
        if ((cleanItem.startsWith('"') && cleanItem.endsWith('"')) || 
            (cleanItem.startsWith("'") && cleanItem.endsWith("'"))) {
          cleanItem = cleanItem.slice(1, -1);
        }
        return cleanItem;
      });
    }

    // C. Fallback: It's just a normal string sentence, return it as a single item list
    return [rawComments];
  }

  // Fallback for unknown types
  return [];
}